/**
 * <Form> — lightweight wrapper around a native <form>.
 *
 * Intentionally thin: the design system stays React-Hook-Form-*agnostic* at
 * the primitive layer (D-08) — RHF integration lives in `<FormField>` (the
 * Controller adapter). This wrapper just provides consistent vertical rhythm
 * and the `noValidate` escape hatch so the browser's native tooltips don't
 * compete with our validation messages.
 */
import * as React from "react";
import { cn } from "../../utils";

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  /** When true (default), `noValidate` is set so browser tooltips don't clash with Zod errors. */
  suppressBrowserValidation?: boolean;
}

export const Form = React.forwardRef<HTMLFormElement, FormProps>(function Form(
  { className, suppressBrowserValidation = true, children, ...rest },
  ref,
) {
  return (
    <form
      ref={ref}
      noValidate={suppressBrowserValidation}
      className={cn("flex flex-col gap-md", className)}
      {...rest}
    >
      {children}
    </form>
  );
});
